import { createContext } from 'react';

const CategoryManagerContext = createContext();

export default CategoryManagerContext;
